import React from 'react'
import './CrumbFeature.css'

export default function CrumbFeature({children}) {
  return (
    <div className='crumbFeature'>
      {children}
    </div>
  )
}
